import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

const QRDocument = ({ qrCode, clinicCode }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.sectionTitle}>Clinic QR Code</Text>
            </View>
            <View style={styles.codeSectionContainer}>
                <Image src={qrCode} style={styles.qrImage} />
            </View>
            <View style={styles.section}>
                <Text style={styles.sectionTitle}>Clinic Code</Text>
            </View>
            <View style={styles.codeSectionContainer}>
                {
                    clinicCode.split("").map((code) => {
                        return <View style={styles.codeSection}>
                            <Text style={styles.codeText}>{code}</Text>
                        </View>
                    })
                }
            </View>
        </Page>
    </Document>
)

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#FFFFFF',
        padding: 10,
    },
    qrImage: {
        width: 300,
        height: 300
    },
    section: {
        marginHorizontal: 10,
        marginVertical: 5,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#000000',
        textAlign: 'center',
    },
    codeSectionContainer: {
        display: 'flex',
        flexDirection: "row",
        marginVertical: 5,
        justifyContent: 'center'
    },
    codeSection: {
        paddingVertical: 12,
        paddingHorizontal: 20,
        backgroundColor: "#FFFFFF",
        border: "2px solid #F1F2F4",
        borderRadius: 6,
        marginHorizontal: 5
    },
    codeText: {
        fontWeight: "500",
        fontSize: 16,
        color: "#25282B"
    }
})

export default QRDocument;
